// removed by extract-text-webpack-plugin
module.exports = {"container":"toolbar__container___1xhfs","name":"toolbar__name___2z9v7","label":"toolbar__label___8SuqE","devices":"toolbar__devices___2_zZQ","devices__container":"toolbar__devices__container___U5BPm","devicesContainer":"toolbar__devices__container___U5BPm","tools":"toolbar__tools___lxFov"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/toolbar.css
// module id = 859
// module chunks = 0